import PayStationFinder from "../../../Utils/PayStationFinder";
import {Roles} from "../../../Models/Roles";
import {AccountType} from "../../../Models/Enums";

const extractReseller = box => {
    if( box?.informations?.sender && box.informations.sender["reseller_id"] ) {
        return { code: box.informations.sender["reseller_id"] };
    }
    return { code: "Error" };
};

const extractCustomer = box => {
    if( box?.informations?.sender && box.informations.sender["customer_code"] ) {
        return { code: box.informations.sender["customer_code"] };
    }
    return { code: "Error" };
};

const filterByName = ( list, filter , accounts ) => {
    if( ! filter ) {
        return list;
    }
    const filtered = [];
    if( list && list.length > 0 ) {
        list.forEach( payStation => {
            try {
                if( payStationMatchesFilter( payStation, filter, accounts ) ) {
                    filtered.push( payStation );
                }
            } catch ( error ) {
                console.error( error );
            }
        } );
    }
    return filtered;
}

//TODO refactor this shit later
const payStationMatchesFilter = ( payStation, filter, accounts ) => {
    if( ! filter || filter.trim() === '' ) return true;

    const cleanedFilter = sanitizeInput( filter );
    const finder = new PayStationFinder( payStation );
    const terminal = ( payStation.terminals && payStation.terminals.length > 0 ) ? payStation.terminals[0] : null;
    const terminalExtraData = finder.buildTerminalExtraData( terminal );
    const reseller = extractReseller( payStation.box );
    const customer = extractCustomer( payStation.box );
    const resellerAccount = accounts?.filter( item => item.code === reseller.code && item.type === AccountType.RESELLER );
    const customerAccount = accounts?.filter( account => account.code === customer.code && account.type === AccountType.CUSTOMER );

    const candidates = [
        payStation.informations?.attributes?.name,
        payStation.box?.informations?.attributes?.name,
        resellerAccount?.length > 0 ? sanitizeInput( resellerAccount[0]?.name ) : null,
        customerAccount?.length > 0 ? sanitizeInput( customerAccount[0]?.name ) : null,
        terminalExtraData,
        ...( payStation.devices?.map( device => device?.informations?.identity?.serial ) || [] ),
        ...( payStation.informations?.attributes?.devices?.map( device => device ) || '' )
    ];

    return candidates.filter( Boolean ).some( candidate => String( candidate ).toLowerCase().includes( cleanedFilter ) );
}

const sanitizeInput = input => {
    return input
        .toString()
        .normalize( 'NFD' )
        .replace( /[\u0300-\u036f]/g, '' ) // Delete diacritics
        .replace( /[\u200B\u200C\u200D\uFEFF\u00A0\u202E]/g, '' ) // Remove zero-width spaces and other invisible characters
        .toLowerCase()
        .trim();
}

//TODO refactor this shit later
const filterPayStations = ( list, filter, accounts ) => {
    if( ! filter ) {
        return list;
    }
    if( list && list.length > 0 ) {
        return list.filter( payStation => payStationMatchesFilter( payStation, filter, accounts ) );
    }
    return list;
}

const filterModules = ( list, filter ) => {
    if( ! filter ) {
        return list;
    }
    if( list && list.length > 0 ) {
        return list.filter( module => module.name.includes( filter ) );
    }
    return list;
}

export { extractCustomer, extractReseller, filterByName , filterPayStations , payStationMatchesFilter , sanitizeInput , filterModules };
